import { CustomStyleSheet } from '../../../utils/rn/tools';
export default CustomStyleSheet({
  'radio-group': {
    flex: 1
  },
  'radio-group__vertical': {
    flexDirection: 'column'
  },
  'radio-group__horizontal': {
    flexDirection: 'row'
  },
  'radio-with-subOptions': {
    flexDirection: 'row',
    paddingRight: 12,
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  'radio-with-subOptions-text': {
    fontSize: 14,
    lineHeight: 24,
    color: 'rgba(0,0,0,.87)',
    flex: 1
  },
  'sub-options': {
    marginLeft: 44,
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderColor: 'rgba(0,0,0,.09)'
  }
});